import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from '../../containers/Tour/messages';

function TourNavigation (props) {
  const { isFirst, isLast } = props;
  const nextBtnMessage = isLast ? messages.finish : messages.nextTip;
  return(
    <div className="myad-tour-navigation">
      {!isFirst && 
        <button className="myad-tour-nav myad-tour-nav--prev" onClick={props.onPrevStep}>
          <i className="afd-icon afd-icon-arrow-circle--left" />
          <FormattedMessage {...messages.previousTip}>
            { txt => <span className="myad-tour-nav__text">{txt}</span> }
          </FormattedMessage>
        </button>
      }
      <button className="myad-tour-nav myad-tour-nav--next" onClick={ isLast ? props.onClose : props.onNextStep}>
        <FormattedMessage textComponent={React.Fragment} {...nextBtnMessage}>
          { txt => <span className="myad-tour-nav__text">{txt}</span> }
        </FormattedMessage>
        <i className="afd-icon afd-icon-arrow-circle" />
      </button>
    </div>
  );
  
}

TourNavigation.propTypes = {
  isFirst: PropTypes.bool.isRequired,
  isLast: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onPrevStep: PropTypes.func.isRequired,
  onNextStep: PropTypes.func.isRequired
};

export default TourNavigation;